import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import type { Project } from "../types/content";
import { ProjectVisual } from "./ProjectVisual";

export function ProjectCard({ project, index, compact = false }: { project: Project; index: number; compact?: boolean }) {
  return (
    <article className={`project-card panel ${compact ? "project-card-compact" : ""}`}>
      <div className="project-card-topline">
        <span className="project-index">P/{String(index + 1).padStart(2, "0")}</span>
        <span className={`status-label status-${project.status.toLowerCase()}`}>{project.status}</span>
      </div>
      <div className="project-visual-wrap">
        <ProjectVisual type={project.visual} />
      </div>
      <div className="project-card-body">
        <p className="eyebrow">{project.eyebrow}</p>
        <h3>{project.title}</h3>
        <p className="project-summary">{project.summary}</p>
        {!compact && (
          <div className="story-pair">
            <div><span>Problem</span><p>{project.problem}</p></div>
            <div><span>Response</span><p>{project.solution}</p></div>
          </div>
        )}
        <ul className="tag-list" aria-label="Technologies">
          {project.technologies.slice(0, compact ? 4 : 6).map((technology) => <li key={technology}>{technology}</li>)}
        </ul>
        <div className="project-links">
          {project.links.slice(0, compact ? 1 : 2).map((link) =>
            link.href.startsWith("/") && !link.external ? (
              <Link key={link.label} to={link.href}>
                {link.label} <ArrowUpRight aria-hidden="true" />
              </Link>
            ) : (
              <a key={link.label} href={link.href} target={link.external ? "_blank" : undefined} rel={link.external ? "noreferrer" : undefined}>
                {link.label} <ArrowUpRight aria-hidden="true" />
              </a>
            ),
          )}
        </div>
      </div>
    </article>
  );
}
